import { observable, action } from "mobx";
import { isDataExist } from "Utils/dataTools";
import * as services from "../services/production";
import { message } from "antd";
import { omit } from "lodash";

class DeviceProduction {
  /* 查询页面数据 */
  @observable isLoading = false;
  @observable deviceList = [];
  @observable maintainList = [];
  @observable maintainPage = { pageIndex: 1, pageSize: 10 };
  @observable deviceType = "";
  @observable maintainType = 1;
  @observable devStatus = "";
  //搜索框选项
  @observable tagList = [
    { name: "全部", key: "" },
    { name: "已排产", key: 2 },
    { name: "生产中", key: 3 },
    { name: "已完成", key: 4 },
    { name: "待排产", key: 1 },
  ];
  @observable checkedTag = 1; //可视化图表,可视化列表选择

  /* 监控详情 */
  @observable modalVisible = false;
  @observable monitorDetailList = [];
  @observable monitorDetailPage = { pageIndex: 1, pageSize: 10 };
  /* -----------设备产况------------ */
  @observable monitorList = []; //设备产况数据
  @observable monitorPage = { pageIndex: 1, pageSize: 12 };
  @observable monitorVisible = false;
  @observable deviceSearchId = "";
  @observable detailInfos = {};
  @observable detailId = "";
  @observable detailInfo = {};
  @observable paramsData = [];
  @observable paramsLoading = false;
  @observable planIds = "";
  @observable searchData = {};


  @action async getMonitor(params) {
    this.isLoading = true;
    try {
      let res = await services.gets("listEquipmentProduction")({
        ...omit(this.monitorPage, "total"),
        ...params,
        deviceId: this.deviceSearchId,
      });
      this.isLoading = false;
      if (isDataExist(res)) {
        this.monitorList = res.data.data.items;
        this.monitorPage = res.data.data.page;
      }
    } catch (error) {
      console.log(error);
    }
  }
  @action async getMonitorDetail(params) {
    try {
      let res = await services.gets("listByPlanId")({
        ...omit(this.monitorDetailPage, "total"),
        ...params,
      });
      this.isLoading = false;
      if (isDataExist(res)) {
        this.monitorDetailList = res.data.data.items;
        this.monitorDetailPage = res.data.data.page;
      }
    } catch (error) {
      console.log(error);
    }
  }

  /* 查询所有的设备名称 */
  @observable devList = [];
  @action async getDeviceAll() {
    try {
      let res = await services.gets("getDeviceAll")();
      if (isDataExist(res)) {
        this.devList = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  @action clearData() {
    /* 查询页面数据 */
    this.isLoading = false;
    this.deviceList = [];
    this.maintainList = [];
    this.maintainPage = { pageIndex: 1, pageSize: 10 };
    this.deviceType = "";
    this.maintainType = 1;
    this.devStatus = "";

    this.checkedTag = 1; //可视化图表,可视化列表选择

    /* 监控详情 */
    this.modalVisible = false;
    this.monitorDetailList = [];
    this.monitorDetailPage = { pageIndex: 1, pageSize: 10 };
    /* -----------设备产况------------ */
    this.monitorList = []; //设备产况数据
    this.monitorPage = { pageIndex: 1, pageSize: 12 };
    this.monitorVisible = false;
    this.deviceSearchId = "";
    this.detailInfos = {};
    this.detailId = "";
    this.detailInfo = {};
    this.paramsData = [];
    this.paramsLoading = false;
    this.planIds = "";
    this.searchData = {};
  }

  @action.bound modifyValue(key, value) {
    this[key] = value;
  }
  //打开/关闭模态框
  @action.bound modalChange(visible) {
    this.modalVisible = visible;
  }
}

let DeviceProductionStore = new DeviceProduction();
export default DeviceProductionStore;
